import type { ListaBlanca } from "@/types/listaBlanca";
import type { ListaEmpresa } from "@/types/listaEmpresa";
import type { ListaDimension } from "@/types/listaDimension";
import type { ProyectoNomenclatura } from "../types/ProyectoNomenclatura"
import axios from "axios";
import type { Ref } from "vue";
import { reactive, ref } from "vue";
import { useStore } from "vuex";
import { key } from "@/store";

export default function useListaBlanca() {
    const store = useStore(key);

    async function getListaBlanca(rut: string, tipo: string | null): Promise<ListaBlanca[]> {
        try {
            let url: string = store.state.url + "api/ListaBlanca/GetListaBlanca?rut=" + rut;
            if (tipo != null && tipo != "") {
                url += "?tipo=" + tipo;
            }

            const response = await axios.get(url, {
                headers: {},
            });

            if (response.status == 200) {
                return response.data as ListaBlanca[];

            } else {
                console.log(response.statusText);
                return [];
            }
        } catch (error: any) {
            console.log(error.message);
            return [];
        }
    }

    async function postListaBlanca(item: Omit<ListaBlanca, 'id'>, usuario: string): Promise<ListaBlanca | null> {
        try {
            const response = await axios.post(
                store.state.url + "api/ListaBlanca/PostListaBlanca?usuario=" + usuario,
                item,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (response.status === 200 || response.status === 201) {
                return response.data as ListaBlanca;
            } else {
                console.log(response.statusText);
                return null;
            }
        } catch (error: any) {
            console.log(error.message);
            // Re-throw para que el componente pueda manejar errores específicos
            throw error;
        }
    }

    async function postListaBlancaMasivo(items: Omit<ListaBlanca, 'id'>[], usuario: string): Promise<boolean> {
        try {
            const response = await axios.post(
                store.state.url + "api/ListaBlanca/PostListaBlancaMasivo?usuario=" + usuario,
                items,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (response.status === 200 || response.status === 201) {
                return response.data as boolean;
            } else {
                console.log(response.statusText);
                return false;
            }
        } catch (error: any) {
            console.log(error.message);
            // Re-throw para que el componente pueda manejar errores específicos
            throw error;
        }
    }

    async function deleteListaBlanca(id: number): Promise<boolean> {
        try {
            const response = await axios.delete(
                store.state.url + `api/ListaBlanca/DeleteListaBlanca?id=${id}`,
                {
                    headers: {},
                }
            );

            if (response.status === 200 || response.status === 204) {
                return response.data as boolean;
            } else {
                console.log(response.statusText);
                return false;
            }
        } catch (error: any) {
            console.log(error.message);
            // Re-throw para que el componente pueda manejar errores específicos
            throw error;
        }
    }

    async function listaEmpresas(): Promise<ListaEmpresa[]> {
        try {
            const response = await axios.get(
                store.state.url + "api/ListaBlanca/ListaEmpresas",
                {
                    headers: {},
                }
            );

            if (response.status === 200) {
                return response.data as ListaEmpresa[];
            } else {
                console.log(response.statusText);
                return [];
            }
        } catch (error: any) {
            console.log(error.message);
            return [];
        }
    }

    async function listaDepartamentos(): Promise<ListaDimension[]> {
        try {
            const response = await axios.get(
                store.state.url + "api/ListaBlanca/ListaDepartamentos",
                {
                    headers: {},
                }
            );

            if (response.status === 200) {
                return response.data as ListaDimension[];
            } else {
                console.log(response.statusText);
                return [];
            }
        } catch (error: any) {
            console.log(error.message);
            return [];
        }
    }

    async function listaProyectos(): Promise<ProyectoNomenclatura[]> {
        try {
            const response = await axios.get(
                store.state.url + "api/ListaBlanca/ListaProyectos",
                {
                    headers: {},
                }
            );

            if (response.status === 200) {
                return response.data as ProyectoNomenclatura[];
            } else {
                console.log(response.statusText);
                return [];
            }
        } catch (error: any) {
            console.log(error.message);
            return [];
        }
    }

    return {
        getListaBlanca,
        postListaBlanca,
        postListaBlancaMasivo,
        deleteListaBlanca,
        listaEmpresas,
        listaDepartamentos,
        listaProyectos,
    };
}
